export default {
    zh: [
        { label: "2014-08-24", value: "yyyy-MM-dd" },
        { label: "2014/8/24", value: "yyyy/M/d" },
        { label: "8/24/2014", value: "M/d/yyyy" },
        { label: "8/24/19", value: "M/d/yy" },
        { label: "24/8/2014", value: "d/M/yyyy" },
        { label: "24/8/19", value: "d/M/yy" },
        { label: "8.24.2104", value: "M.d.yyyy" },
        { label: "24.8.2014", value: "d.M.yyyy" },
        { label: "19-8-24", value: "yy-M-d" },
        { label: "08-24-19", value: "MM-dd-yy" },
        { label: "八月 24,2014", value: "MMMM d,yyyy" },
        { label: "星期日,八月 24,2014", value: "dddd,MMMM dd,yyyy" },
        { label: "24 八月 2014", value: "d MMMM yyyy" },
        { label: "24-8八月-19", value: "d-MMM-yy" },
        { label: "8月.24,19", value: "MMM.d,yy" },
        { label: "八月 19", value: "MMMM yy" },
        { label: "8月-19", value: "MMM-yy" },
        { label: "2014", value: "yyyy" },
        { label: "8月", value: "MMM" },
        { label: "8/24/2014 8:07:00 下午", value: "M/d/yyyy h:mm:ss ap" },
        { label: "8/24/2014 8:07 下午", value: "M/d/yyyy h:mm ap" },
        { label: "24/8/2014 8:07:00 下午", value: "d/M/yyyy h:mm:ss ap" },
        { label: "24/8/2014 8:07 下午", value: "d/M/yyyy h:mm ap" },
        { label: "8:07 下午", value: "h:mm ap" },
        { label: "8:07:00 下午", value: "h:mm:ss ap" },
        { label: "20:07", value: "hh:mm" },
        { label: "20:07:00", value: "hh:mm:ss" },
        { label: "20", value: "hh" },
        { label: "07", value: "mm" },
        { label: "00", value: "ss" },
    ],
    en: [
        { label: "2014-08-24", value: "yyyy-MM-dd" },
        { label: "2014/8/24", value: "yyyy/M/d" },
        { label: "8/24/2014", value: "M/d/yyyy" },
        { label: "8/24/19", value: "M/d/yy" },
        { label: "24/8/2014", value: "d/M/yyyy" },
        { label: "24/8/19", value: "d/M/yy" },
        { label: "8.24.2104", value: "M.d.yyyy" },
        { label: "24.8.2014", value: "d.M.yyyy" },
        { label: "19-8-24", value: "yy-M-d" },
        { label: "08-24-19", value: "MM-dd-yy" },
        { label: "August 24,2014", value: "MMMM d,yyyy" },
        { label: "Sunday,August 24,2014", value: "dddd,MMMM dd,yyyy" },
        { label: "24 August 2014", value: "d MMMM yyyy" },
        { label: "24-August-19", value: "d-MMM-yy" },
        { label: "August.24,19", value: "MMM.d,yy" },
        { label: "August 19", value: "MMMM yy" },
        { label: "August-19", value: "MMM-yy" },
        { label: "2014", value: "yyyy" },
        { label: "August", value: "MMM" },
        { label: "8/24/2014 8:07:00 PM", value: "M/d/yyyy h:mm:ss ap" },
        { label: "8/24/2014 8:07 PM", value: "M/d/yyyy h:mm ap" },
        { label: "24/8/2014 8:07:00 PM", value: "d/M/yyyy h:mm:ss ap" },
        { label: "24/8/2014 8:07 PM", value: "d/M/yyyy h:mm ap" },
        { label: "8:07 PM", value: "h:mm ap" },
        { label: "8:07:00 PM", value: "h:mm:ss ap" },
        { label: "20:07", value: "hh:mm" },
        { label: "20:07:00", value: "hh:mm:ss" },
        { label: "20", value: "hh" },
        { label: "07", value: "mm" },
        { label: "00", value: "ss" },
    ],
    jp: [
        { label: "2014-08-24", value: "yyyy-MM-dd" },
        { label: "2014/8/24", value: "yyyy/M/d" },
        { label: "8/24/2014", value: "M/d/yyyy" },
        { label: "8/24/19", value: "M/d/yy" },
        { label: "24/8/2014", value: "d/M/yyyy" },
        { label: "24/8/19", value: "d/M/yy" },
        { label: "8.24.2104", value: "M.d.yyyy" },
        { label: "24.8.2014", value: "d.M.yyyy" },
        { label: "19-8-24", value: "yy-M-d" },
        { label: "08-24-19", value: "MM-dd-yy" },
        { label: "八月 24,2014", value: "MMMM d,yyyy" },
        { label: "日曜日,八月 24,2014", value: "dddd,MMMM dd,yyyy" },
        { label: "24 八月 2014", value: "d MMMM yyyy" },
        { label: "24-8八月-19", value: "d-MMM-yy" },
        { label: "8月.24,19", value: "MMM.d,yy" },
        { label: "八月 19", value: "MMMM yy" },
        { label: "8月-19", value: "MMM-yy" },
        { label: "2014", value: "yyyy" },
        { label: "8月", value: "MMM" },
        { label: "8/24/2014 8:07:00 午後", value: "M/d/yyyy h:mm:ss ap" },
        { label: "8/24/2014 8:07 午後", value: "M/d/yyyy h:mm ap" },
        { label: "24/8/2014 8:07:00 午後", value: "d/M/yyyy h:mm:ss ap" },
        { label: "24/8/2014 8:07 午後", value: "d/M/yyyy h:mm ap" },
        { label: "8:07 午後", value: "h:mm ap" },
        { label: "8:07:00 午後", value: "h:mm:ss ap" },
        { label: "20:07", value: "hh:mm" },
        { label: "20:07:00", value: "hh:mm:ss" },
        { label: "20", value: "hh" },
        { label: "07", value: "mm" },
        { label: "00", value: "ss" },
    ],
    fr: [
        { label: "2014-08-24", value: "yyyy-MM-dd" },
        { label: "2014/8/24", value: "yyyy/M/d" },
        { label: "8/24/2014", value: "M/d/yyyy" },
        { label: "8/24/19", value: "M/d/yy" },
        { label: "24/8/2014", value: "d/M/yyyy" },
        { label: "24/8/19", value: "d/M/yy" },
        { label: "8.24.2104", value: "M.d.yyyy" },
        { label: "24.8.2014", value: "d.M.yyyy" },
        { label: "19-8-24", value: "yy-M-d" },
        { label: "08-24-19", value: "MM-dd-yy" },
        { label: "le 24 août 2014", value: "MMMM d,yyyy" },
        { label: "dimanche, le 24 août 2014", value: "dddd,MMMM dd,yyyy" },
        // { label: "le 24 août 2014", value: "d MMMM yyyy" },
        { label: "19/08/2019", value: "d-MMM-yy" },
        { label: "19 août 2019", value: "MMM.d,yy" },
        { label: "le 19 août", value: "MMMM yy" },
        { label: "19, août", value: "MMM-yy" },
        { label: "2014", value: "yyyy" },
        { label: "août", value: "MMM" },
        { label: "8/24/2014 8:07:00 après-midi", value: "M/d/yyyy h:mm:ss ap" },
        { label: "8/24/2014 8:07 après-midi", value: "M/d/yyyy h:mm ap" },
        { label: "24/8/2014 8:07:00 après-midi", value: "d/M/yyyy h:mm:ss ap" },
        { label: "24/8/2014 8:07 après-midi", value: "d/M/yyyy h:mm ap" },
        { label: "8:07 après-midi", value: "h:mm ap" },
        { label: "8:07:00 après-midi", value: "h:mm:ss ap" },
        { label: "20:07", value: "hh:mm" },
        { label: "20:07:00", value: "hh:mm:ss" },
        { label: "20", value: "hh" },
        { label: "07", value: "mm" },
        { label: "00", value: "ss" },
    ],
    de: [
        { label: "2014-08-24", value: "yyyy-MM-dd" },
        { label: "2014/8/24", value: "yyyy/M/d" },
        { label: "8/24/2014", value: "M/d/yyyy" },
        { label: "8/24/19", value: "M/d/yy" },
        { label: "24/8/2014", value: "d/M/yyyy" },
        { label: "24/8/19", value: "d/M/yy" },
        { label: "8.24.2104", value: "M.d.yyyy" },
        { label: "24.8.2014", value: "d.M.yyyy" },
        { label: "19-8-24", value: "yy-M-d" },
        { label: "08-24-19", value: "MM-dd-yy" },
        { label: "24. August 2014", value: "MMMM d,yyyy" },
        { label: "Sonntag, 24. August 2014", value: "dddd,MMMM dd,yyyy" },
        // { label: "24. August 2014", value: "d MMMM yyyy" },
        // { label: "24. August 2019", value: "d-MMM-yy" },
        // { label: "24. August 2019", value: "MMM.d,yy" },
        { label: "19. August", value: "MMMM yy" },
        // { label: "19. August", value: "MMM-yy" },
        { label: "2014", value: "yyyy" },
        { label: "August", value: "MMM" },
        { label: "8/24/2014 8:07:00 Nachmittag", value: "M/d/yyyy h:mm:ss ap" },
        { label: "8/24/2014 8:07 Nachmittag", value: "M/d/yyyy h:mm ap" },
        { label: "24/8/2014 8:07:00 Nachmittag", value: "d/M/yyyy h:mm:ss ap" },
        { label: "24/8/2014 8:07 Nachmittag", value: "d/M/yyyy h:mm ap" },
        { label: "8:07 Nachmittag", value: "h:mm ap" },
        { label: "8:07:00 Nachmittag", value: "h:mm:ss ap" },
        { label: "20:07", value: "hh:mm" },
        { label: "20:07:00", value: "hh:mm:ss" },
        { label: "20", value: "hh" },
        { label: "07", value: "mm" },
        { label: "00", value: "ss" },
    ],
    es: [
        { label: "2014-08-24", value: "yyyy-MM-dd" },
        { label: "2014/8/24", value: "yyyy/M/d" },
        { label: "8/24/2014", value: "M/d/yyyy" },
        { label: "8/24/19", value: "M/d/yy" },
        { label: "24/8/2014", value: "d/M/yyyy" },
        { label: "24/8/19", value: "d/M/yy" },
        { label: "8.24.2104", value: "M.d.yyyy" },
        { label: "24.8.2014", value: "d.M.yyyy" },
        { label: "19-8-24", value: "yy-M-d" },
        { label: "08-24-19", value: "MM-dd-yy" },
        { label: "24 de agosto, 2014", value: "MMMM d,yyyy" },
        { label: "domingo, 24 de agosto, 2014", value: "dddd,MMMM dd,yyyy" },
        // { label: "24 de agosto, 2014", value: "d MMMM yyyy" },
        // { label: "19 de agosto, 2014", value: "d-MMM-yy" },
        // { label: "19 de agosto, 2014", value: "MMM.d,yy" },
        { label: "19 de agosto", value: "MMMM yy" },
        { label: "agosto，2019", value: "MMM-yy" },
        { label: "2014", value: "yyyy" },
        { label: "agosto", value: "MMM" },
        { label: "8/24/2014 8:07:00 De la tarde", value: "M/d/yyyy h:mm:ss ap" },
        { label: "8/24/2014 8:07 De la tarde", value: "M/d/yyyy h:mm ap" },
        { label: "24/8/2014 8:07:00 De la tarde", value: "d/M/yyyy h:mm:ss ap" },
        { label: "24/8/2014 8:07 De la tarde", value: "d/M/yyyy h:mm ap" },
        { label: "8:07 De la tarde", value: "h:mm ap" },
        { label: "8:07:00 De la tarde", value: "h:mm:ss ap" },
        { label: "20:07", value: "hh:mm" },
        { label: "20:07:00", value: "hh:mm:ss" },
        { label: "20", value: "hh" },
        { label: "07", value: "mm" },
        { label: "00", value: "ss" },
    ],
    pt: [
        { label: "2014-08-24", value: "yyyy-MM-dd" },
        { label: "2014/8/24", value: "yyyy/M/d" },
        { label: "8/24/2014", value: "M/d/yyyy" },
        { label: "8/24/19", value: "M/d/yy" },
        { label: "24/8/2014", value: "d/M/yyyy" },
        { label: "24/8/19", value: "d/M/yy" },
        { label: "8.24.2104", value: "M.d.yyyy" },
        { label: "24.8.2014", value: "d.M.yyyy" },
        { label: "19-8-24", value: "yy-M-d" },
        { label: "08-24-19", value: "MM-dd-yy" },
        { label: "2014-08-24", value: "MMMM d,yyyy" },
        { label: "24/08/2014", value: "dddd,MMMM dd,yyyy" },
        { label: "24-agosto-2014", value: "d MMMM yyyy" },
        { label: "24, agosto, 19", value: "d-MMM-yy" },
        // { label: "24, agosto, 19", value: "MMM.d,yy" },
        { label: "agosto, 19", value: "MMMM yy" },
        { label: "agosto-19", value: "MMM-yy" },
        { label: "2014", value: "yyyy" },
        { label: "agosto", value: "MMM" },
        { label: "8/24/2014 8:07:00 Tarde", value: "M/d/yyyy h:mm:ss ap" },
        { label: "8/24/2014 8:07 Tarde", value: "M/d/yyyy h:mm ap" },
        { label: "24/8/2014 8:07:00 Tarde", value: "d/M/yyyy h:mm:ss ap" },
        { label: "24/8/2014 8:07 Tarde", value: "d/M/yyyy h:mm ap" },
        { label: "8:07 Tarde", value: "h:mm ap" },
        { label: "8:07:00 Tarde", value: "h:mm:ss ap" },
        { label: "20:07", value: "hh:mm" },
        { label: "20:07:00", value: "hh:mm:ss" },
        { label: "20", value: "hh" },
        { label: "07", value: "mm" },
        { label: "00", value: "ss" },
    ],
    it: [
        { label: "2014-08-24", value: "yyyy-MM-dd" },
        { label: "2014/8/24", value: "yyyy/M/d" },
        { label: "8/24/2014", value: "M/d/yyyy" },
        { label: "8/24/19", value: "M/d/yy" },
        { label: "24/8/2014", value: "d/M/yyyy" },
        { label: "24/8/19", value: "d/M/yy" },
        { label: "8.24.2104", value: "M.d.yyyy" },
        { label: "24.8.2014", value: "d.M.yyyy" },
        { label: "19-8-24", value: "yy-M-d" },
        { label: "08-24-19", value: "MM-dd-yy" },
        { label: "24/8/2014", value: "MMMM d,yyyy" },
        { label: "domenica, 24/8/2014", value: "dddd,MMMM dd,yyyy" },
        { label: "24 agosto 2014", value: "d MMMM yyyy" },
        { label: "24-agosto-2019", value: "d-MMM-yy" },
        { label: "ventiquattro agosto 2019", value: "MMM.d,yy" },
        { label: "Agosto-2019", value: "MMMM yy" },
        { label: "Ago-2019", value: "MMM-yy" },
        { label: "2014", value: "yyyy" },
        { label: "Agosto", value: "MMM" },
        { label: "8/24/2014 8:07:00 Pomeriggio", value: "M/d/yyyy h:mm:ss ap" },
        { label: "8/24/2014 8:07 Pomeriggio", value: "M/d/yyyy h:mm ap" },
        { label: "24/8/2014 8:07:00 Pomeriggio", value: "d/M/yyyy h:mm:ss ap" },
        { label: "24/8/2014 8:07 Pomeriggio", value: "d/M/yyyy h:mm ap" },
        { label: "8:07 Pomeriggio", value: "h:mm ap" },
        { label: "8:07:00 Pomeriggio", value: "h:mm:ss ap" },
        { label: "20:07", value: "hh:mm" },
        { label: "20:07:00", value: "hh:mm:ss" },
        { label: "20", value: "hh" },
        { label: "07", value: "mm" },
        { label: "00", value: "ss" },
    ],
};
